import { render, staticRenderFns } from "./PublishedNewNote.vue?vue&type=template&id=4facb649&"
import script from "./PublishedNewNote.vue?vue&type=script&lang=js&"
export * from "./PublishedNewNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports